export default __webpack_public_path__ + "static/media/FB_IMG_1601536165235.56f65158.jpg";